












import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import providers from "@/lib/api";
import BasePage from "@/components/BasePage";
import SixDigitConfirmView from "@/components/SixDigitConfirmView";

export default defineComponent({
  name: "PageForgotPasswordConfirmCode",
  components: { SixDigitConfirmView, BasePage },
  props: {
    email: { type: String, default: "" },
    changePassword: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      token: "",
    };
  },
  computed: {
    nextRoute(): Location {
      if (!this.changePassword) {
        return {
          name: "loginForgotSet",
          params: { email: this.email, token: this.token },
        };
      }
      return {
        name: "changePasswordSet",
        params: { token: this.token },
      };
    },
  },
  methods: {
    codeResend() {
      if (this.loading) return;
      try {
        this.loading = true;
        providers.PasswordResetProvider.start({ data: { email: this.email } });
      } finally {
        this.loading = false;
      }
    },
    async submit(code?: string) {
      if (!code) {
        alert("Enter verification code");
        return;
      }
      try {
        this.loading = true;
        let data = await providers.PasswordResetProvider.verify({ data: { code: code, email: this.email } });
        this.token = data?.token ?? "";
        if (this.token) this.$router.push(this.nextRoute);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    if (!this.changePassword) return;
    providers.PasswordResetProvider.start({ data: { email: this.email } });
  },
});
